import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { VueFire, VueFireFirestoreOptionsAPI } from "vuefire";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { firebaseApp } from "@/firebase/firebase";

const vuetify = createVuetify({
  components,
  directives,
});

createApp(App)
  .use(router)
  .use(vuetify)
  .use(VueFire, {
    firebaseApp,
    modules: [VueFireFirestoreOptionsAPI()],
  })
  .mount("#app");
